import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from '../actionHelpers';
import queryString from 'query-string';

export const ADMIN_NEWS_ARTICLES_SEARCH = 'ADMIN_NEWS_ARTICLES_SEARCH';
export const ADMIN_NEWS_ARTICLES_SEARCH_SUCCESS = 'ADMIN_NEWS_ARTICLES_SEARCH_SUCCESS';
export const ADMIN_NEWS_ARTICLES_SEARCH_FAILURE = 'ADMIN_NEWS_ARTICLES_SEARCH_FAILURE';

export const ADMIN_NEWS_ARTICLES_SET_SEARCH_PARAMETERS = 'ADMIN_NEWS_ARTICLES_SET_SEARCH_PARAMETERS';

export const ADMIN_NEWS_ARTICLES_GET = 'ADMIN_NEWS_ARTICLES_GET';
export const ADMIN_NEWS_ARTICLES_CREATE = 'ADMIN_NEWS_ARTICLES_CREATE';
export const ADMIN_NEWS_ARTICLES_UPDATE = 'ADMIN_NEWS_ARTICLES_UPDATE';

export const searchNewsArticles = searchParameters => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_NEWS_ARTICLES_SEARCH),
        endpoint: `/api/admin/newsArticles?${queryString.stringify(searchParameters)}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const getNewsArticle = id => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_NEWS_ARTICLES_GET),
        endpoint: `/api/admin/newsArticles/${id}`,
        headers: createHeaders(false),
        method: 'GET'
    }
});

export const createNewsArticle = newsArticle => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_NEWS_ARTICLES_CREATE),
        endpoint: '/api/admin/newsArticles',
        headers: createHeaders(true),
        method: 'POST',
        body: JSON.stringify(newsArticle)
    }
});

export const updateNewsArticle = (id, newsArticle) => ({
    [RSAA]: {
        types: createRsaaTypes(ADMIN_NEWS_ARTICLES_UPDATE),
        endpoint: `/api/admin/newsArticles/${id}`,
        headers: createHeaders(true),
        method: 'PUT',
        body: JSON.stringify(newsArticle)
    }
});

export const setSearchParameters = searchParameters => ({
    type: ADMIN_NEWS_ARTICLES_SET_SEARCH_PARAMETERS,
    searchParameters
});
